<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoDetalhar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoDetalhar">
            <form>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="loading">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-full mb-5">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div
                        class="p-fluid p-formgrid grid pt-3 px-3 mb-5"
                        *ngIf="tipoPagamento && !loading"
                    >
                        <div class="col-12 card-simple mb-5">
                            <div class="p-fluid p-formgrid grid">
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Descrição</label>
                                    <label class="label-inferior" id="descricao">
                                        {{ tipoPagamento.descricao }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Bandeira</label>
                                    <label class="label-inferior" id="bandeira">
                                        {{ tipoPagamento.bandeira }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Transação</label>
                                    <label class="label-inferior" id="transação">
                                        {{ tipoPagamento.transacao }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Meio Pagamento</label>
                                    <label class="label-inferior" id="operacao">
                                        {{ tipoPagamento.meioPagamentoTributario?.descricao }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Antecipação</label>
                                    <label class="label-inferior" id="antencipacao">
                                        {{ tipoPagamento.antecipacao | number: "1.2-2" }}%
                                    </label>
                                </div>

                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Operação</label>
                                    <label class="label-inferior" id="operacao">
                                        {{ tipoPagamento.operacao?.descricao }} -
                                        {{ tipoPagamento.operacao?.conta?.descricao }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="w-full">
                            <div class="field">
                                <h5>Parcelas</h5>
                            </div>

                            <p-table
                                #dt1
                                [value]="parcelas"
                                dataKey="id"
                                [rows]="10"
                                [rowHover]="true"
                                styleClass="p-datatable-gridlines"
                                [paginator]="false"
                                responsiveLayout="scroll"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>
                                            <div
                                                class="flex justify-content-between align-items-center"
                                            >
                                                Parcela
                                            </div>
                                        </th>
                                        <th>
                                            <div
                                                class="flex justify-content-between align-items-center"
                                            >
                                                Prazo
                                            </div>
                                        </th>

                                        <th>
                                            <div
                                                class="flex justify-content-between align-items-center"
                                            >
                                                Taxa Operadora
                                            </div>
                                        </th>
                                        <th>
                                            <div
                                                class="flex justify-content-between align-items-center"
                                            >
                                                Status
                                            </div>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <label>{{ item.quantidadeParcelas }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.prazo }}</label>
                                        </td>

                                        <td>
                                            <label>
                                                {{ item.descontoFinanceira | number: "1.2-2" }}%
                                            </label>
                                        </td>
                                        <td>
                                            <label
                                                class="product-badge status-instock"
                                                id="status"
                                                *ngIf="item.status"
                                            >
                                                ATIVA
                                            </label>
                                            <label
                                                class="product-badge status-outofstock"
                                                id="status"
                                                *ngIf="!item.status"
                                            >
                                                INATIVA
                                            </label>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro cadastrado.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/tipo-pagamento"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
